import React, { useRef, useCallback } from 'react';

import { useClickOutside } from '../../hooks';

import { SvgIcon } from '../../design-system';
import DiscussLineIcon from '../../design-system/Icons/DiscussLineIcon';

const SelectionPopup = ({ position, onQuoteClick, onClickOutside }) => {
    const popupRef = useRef(null);

    const handleClickOutside = useCallback((event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            const selection = window.getSelection();
            if (selection.rangeCount > 0 && selection.toString().trim()) {
                return;
            }
            onClickOutside && onClickOutside();
        }
    }, []);

    useClickOutside(popupRef, handleClickOutside);

    return (
        <button
            ref={popupRef}
            onClick={onQuoteClick}
            className="w-9 h-9 rounded-2 bg-neutral-500 flex items-center justify-center shadow-inset-1 shadow-neutral-300"
            style={{
                position: 'absolute',
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 3,
            }}
        >
            <SvgIcon color="#D9E56E" icon={DiscussLineIcon} size="medium" />
        </button>
    );
};

export default SelectionPopup;
